<template>
    <div
      class="wish-btn_with-text"
      @click="handlerWishAdd"
    >
      <div
        class="wish-btn"
      >
        <img
          v-if="!isWish"
          src="~/assets/img/svg/common/heart.svg"
          alt="избранное"
        >
        <img
          v-else
          src="~/assets/img/svg/common/heart-fill.svg"
          alt="избранное"
        >
      </div>
      <span class="wish-btn__text">В избранное</span>
    </div>
</template>

<script setup lang="ts">
import useSitisWish from '#sitis/composables/useSitisWish';

const { $ym } = useNuxtApp();
const { productId } = defineProps<{
	productId: number;
}>();
const {
  getWishList,
  removeItemFromWishList,
  addToWishList,
  isInWish
} = useSitisWish();

const isWish = computed(() => isInWish(productId));

const handlerWishAdd = async () => {
  if (isWish.value) {
    await removeItemFromWishList(productId);
  } else {
    await addToWishList({ id: productId });

    if (typeof $ym === 'function') {
      $ym('reachGoal', 'add_to_wishlist');
    }
  }

  await getWishList();
};
</script>

<style scoped lang="scss">
.wish-btn_with-text {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  & > .wish-btn {
    width: 20px;
    height: 20px;
  }
  &:hover {
    & > .wish-btn__text {
      text-decoration: underline;
    }
    & > .wish-btn > img {
      transform: scale(1.1)
    }
  }
}
.wish-btn__text {
  font-weight: 600;
  font-size: 16px;
  line-height: 1.4;
  color: var(--silver);
}
</style>
